import { useState } from "react";
import { Navigate, Outlet, useNavigate } from "react-router-dom";
import { useStateGetter } from "../../hooks/statehooks/UseStateGettersHook";
import { useOrganizationHook } from "../../hooks/useOrganizationHook";

const Activity = () => {
  const [activecompany, setactivecompany] = useState("Notifications");
  const { UserOrgs } = useOrganizationHook();
  const navigate=useNavigate()

  const activityItems = [
    { name: "Notifications", path: "notifications" },
    { name: "Audit Log", path: "audits" },
  ];
  const Activityselect = (props: any) => (
    <div
      onClick={() => {
        setactivecompany(props.item.name);
        navigate(`/home/activity/${props.item.path}`)

    
      }}
      className={` m-2 rounded-[8px]    p-2  font-semibold ${
        props.item.name == activecompany
          ? "bg-textbg text-white"
          : " bg-faintBlue text-blueGray "
      }`}
    >
      <p className="  cursor-pointer text-xs">{props.item.name}</p>
    </div>
  );

  return (
    <div className="w-full flex justify-center items-start">
      <div className="w-[40%] mt-4 bg-white rounded-[20px] flex flex-col px-3  items-start md: min-h-[80vh] ">
        <div className="w-full flex ">
          {activityItems.map((i) => (
            <Activityselect item={i} />
          ))}
        </div>
        <hr />




        <div className="w-full">
            <Outlet/>
        </div>
      </div>
    </div>
  );
};
export { Activity };
